import { useCallback } from 'react';
import { Button } from '../components/Button';
import { Player1, Player2, Player3, Player4 } from '../components/PlayerSelect';
import { View } from '../components/View';
import { useGameStore } from '../hooks/useGameStore';

export function PlayerView() {
  const [playerName, next] = useGameStore(
    useCallback((state) => [state.playerName, state.nextView], [])
  );

  return (
    <View title="Välj spelare">
      <div className="flex flex-row space-x-10 mt-8 mb-10 xl:mb-16">
        <Player1 />
        <Player2 />
        <Player3 />
        <Player4 />
      </div>

      <Button disabled={playerName === ''} onClick={() => next()}>
        Starta spelet!
      </Button>
    </View>
  );
}
